"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.runWithProgressIndicator = runWithProgressIndicator;
const downloadIndicatorInterval = 1000; // same as vscode-dotnet-runtime
async function runWithProgressIndicator(callback, logger) {
    const timer = setInterval(() => logger.append("."), downloadIndicatorInterval);
    try {
        await callback();
    }
    finally {
        clearTimeout(timer);
        logger.appendLine("");
    }
}
//# sourceMappingURL=progressIndicator.js.map